import axios from '../config/axios';
import { store } from '../../js/store';

export async function tareasPendientesPaciente(document) {
  return await axios.post(
    `/consultas_tareas_crm/tareas_crm/api/v1/read_task`,
    {
      document
    }
  );
}
/**
 * Crear seguimiento.
 * @param {*} tipo_esquema 
 * @param {*} documento 
 * @param {*} creado_por 
 */
export async function crearEncuentroSeguimiento(
  tipo_esquema,
  documento,
  creado_por
) {
  try {
    return await axios.post(
      "/seguimiento_consultas/seguimientos/api/v1/crear_seguimiento",
      {
        tipo_esquema,
        documento,
        creado_por,
      }
    );
  } catch (error) {
    return error;
  }
}

/**
 * Consultar los seguimientos crados.
 * @param {*} nombre 
 * @param {*} id 
 */
export function consultarListaCuestionario(nombre, id) {
  return new Promise((resolve, reject) => {
    axios
      .get("/seguimiento_consultas/seguimientos/api/v2/cuestionarios", {
        params: {
          nombre,
          id,
        },
      })
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Eliminar seguimiento.
 * @param {*} docId 
 */
export async function eliminarSeguimiento(docId) {
  try {
    return await axios.request({
      method: "delete",
      url: "/seguimiento_consultas/seguimientos/api/v1/eliminar",
      data: { docId },
    });
  } catch (error) {
    return error;
  }
}


// WEBPACK FOOTER //
// ./src/apiService/request/CrudTareasPaciente.js